import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Flex,
  Text,
  Grid,
  GridItem,
  Switch,
  Card,
} from "@chakra-ui/react";
import PortfolioItem from "./PortfolioItem";
import { portfolio } from "../../info/portfolioInfo";
import { designPortfolio } from "../../info/designinfo";
import LabelSwitch from "./LabelSwitch";
import DesignItem from "../DesignItem";
import { anim_portfolio } from "../../info/anim_info";
import PortfolioPick from "./PortfolioPick";

export default function Work() {
  const [activeIdx, setActiveIdx] = useState<number>(0);
  portfolio.sort((a, b) => b.year - a.year);

  return (
    <div id="work" style={{ scrollSnapType: "y" }}>
      <Grid
        scrollSnapType="y"
        templateAreas={{
          lg: `"header main"
                    "control main"`,
          base: `"header"
              "control"
              "main"`,
        }}
        gridTemplateRows={{ lg: "6rem 1fr", base: "10vh 0rem 75vh" }}
        gridTemplateColumns={{ lg: "1fr 3fr", base: "1fr" }}
        py="5rem"
        pl={{ lg: "8rem", base: "auto" }}
        height="100vh"
      >
        <GridItem area={"header"}>
          <Text  variant={"subHeader"}
              textAlign={{ base: "center" }}
              lineHeight={"80%"}
              color="darkestgrey">
            Technical Projects
          </Text>
        </GridItem>
        <GridItem
          area={"control"}
          display={{ lg: "flex", base: "none" }}
          flexDir="column"
          justifyContent="flexStart"
          alignItems="center"
          height="100%"
          p="0"
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            flexDir={"column"}
            width="70%"
            _hover={{
              width: "100%",
            }}
            transition="all 1s ease"
          >
            {portfolio.map((p, i) => (
              <PortfolioPick
                title={p.title}
                year={p.year}
                active={activeIdx == i}
                idx={i}
                setActiveIdx={setActiveIdx}
              />
            ))}
          </Flex>
        </GridItem>
        <GridItem
          area={"main"}
          display="flex"
          alignItems={{ base: "center", lg: "flex-end" }}
          flexDir={"column"}
          overflowX={"hidden"}
        >
          <PortfolioItem
            title={portfolio[activeIdx].title}
            desc={portfolio[activeIdx].desc}
            link={portfolio[activeIdx].link}
            linkLabel={portfolio[activeIdx].linkLabel}
            role={portfolio[activeIdx].role}
            tags={portfolio[activeIdx].tags}
            image={portfolio[activeIdx].image}
            bullets={portfolio[activeIdx].bullets}
            activeIdx={activeIdx}
            setActiveIdx={setActiveIdx}
          />
          <Flex
            alignItems={"center"}
            justifyContent={"center"}
            width="90%"
            gap="2rem"
          >
            <Button
              variant="outlineSmall"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              onClick={(c) => {
                if (activeIdx == 0) {
                  setActiveIdx(portfolio.length - 1);
                } else {
                  setActiveIdx(activeIdx - 1);
                }
              }}
            >
              previous
            </Button>
            <Button
              variant="outlineSmall"
              color="lightblue"
              borderColor="lightblue"
              _hover={{ borderColor: "black", color: "black" }}
              onClick={(c) => {
                if (activeIdx == portfolio.length - 1) {
                  setActiveIdx(0);
                } else {
                  setActiveIdx(activeIdx + 1);
                }
              }}
            >
              next
            </Button>
          </Flex>
        </GridItem>
      </Grid>
    </div>
  );
}
